import WorkplaceRequirementEdit from '@/components/ezuro/constants/workplaces/requirements/edit/WorkplaceRequirementEdit.vue'

export default {
  name: 'WorkplaceRequirements',
  components: {
    WorkplaceRequirementEdit
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      workplace: {},
      events: null,
      isLoading: false,
      isMounted: false
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id') },
        { key: 'job_id', label: this.$t('workplace.requirements.job'), format: 'formatFunc', funcs: [this.getValueName] },
        { key: 'amount', label: this.$t('workplace.requirements.amount') }
      ];

      const actions = [
        { label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' },
        { label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger' }
      ];

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      actions.add = { title: this.$t('general.actions.add') };
      return actions;
    },
    getTitle () {
      return this.$t('workplace.requirements.title', { name: this.workplace.name });
    }
  },
  methods: {
    getValueName (value, row) {
      return this.$store.getters.getParamFromConfig('company_jobs', value, 'name', this.$i18n.locale);
    },
    loadEvents () {
      const path = `ezuro/workplaces/requirements/list/${this.workplace.id}`;

      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.events = response.data;
          this.isLoading = false;
        }
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el, this.workplace);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: this.getValueName(el.job_id, el), code: el.id }))
      }
    },
    setDeleted (el, isDeleted) {
      this.isLoading = true;
      this.ApiRequest.request('ezuro/workplaces/requirements/destroy/' + el.id, this.ApiRequest.REQUEST_GET, { }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.isLoading = false;
        } else {
          this.loadEvents();
        }
      });
    },
    show (elData) {
      this.workplace = elData;
      this.loadEvents();

      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    }
  },
  mounted () {
    this.isMounted = true;
  }
}
